import styled from "styled-components/macro";

export const SuperadminWrapper = styled.div`
position: fixed;
top: 0;
left: 0;
width: 100%; 
height: 6px;
background-color: red;
background-color: ${(props) => props.theme.colors.highlight};
z-index: 999999999999999999;
`
export const SuperAdminOrganizationBadge = styled.div`
position: fixed;
top: 6px;
left: 0px;
width: 240px;
height: 25px;
padding: 0 6px 6px 6px;
background-color: ${(props) => props.theme.colors.highlight};
color: #FFF;
display: flex;
flex-direction: column;
transition: height 0.3s ease-in-out;
overflow: hidden;
 
/* height: 380px; */
 
&:hover {
  transition: height 0.3s ease-in-out;
  height: 380px;
  overflow: hidden;
}

@media (max-width: 1200px) {
  display: none;
}
`

export const SuperAdminOrganizationBadgeHeader = styled.div`
display: flex;
justify-content: space-between;
`

export const SuperAdminOrganizationBadgeContent = styled.div`
display: flex;
flex-direction: column;
margin-top: 15px;
justify-content: space-between;
background-color: ${(props) => props.theme.colors.highlight};

`
